import { useEffect } from "react"
import { setError, setSubmitMobileNumberResponse, setLoading } from "../redux/MobileNumberReducer"
import { postCareerNavigatorRequest } from "../api/GoodWillApi"
import { getErrorFromModel } from "../utils/Helper"
import { Actions } from "../redux/Actions"
import { CareerNavigatorRequestModel } from "../models/CareerNavigatorRequestModel"


export const useSubmitMobileNumber = (dispatch: any, isConnected: boolean = false, careerNavigatorRequestModel: CareerNavigatorRequestModel) => {
    useEffect(() => {
        if (isConnected === true) {
            submitMobileNumber(dispatch, careerNavigatorRequestModel)
        }
    }, [isConnected])

    return submitMobileNumber
}

export async function submitMobileNumber(dispatch: any, careerNavigatorRequestModel: CareerNavigatorRequestModel) {
    dispatch(setLoading(true))
    const requestResponse = await postCareerNavigatorRequest(careerNavigatorRequestModel)
    if (requestResponse.status === 200) {
        const error = getErrorFromModel(requestResponse)
        dispatch(typeof requestResponse === 'string' ? setError({ errorMessage: requestResponse, operation: Actions.SUBMIT_MOBILE_NUMBER }) : (error.errorMessage ? setError(error) : setSubmitMobileNumberResponse(requestResponse)))
    } else {
        dispatch(setError({ errorMessage: 'Server Error', operation: Actions.SUBMIT_MOBILE_NUMBER }))
    }
    dispatch(setLoading(false))
}